export function SnsTextGeneration(type: string): string {
  return type === "Twitter" ? "X" : type;
}
